const services = require("./services.json");
const extra = require("./locationExtra.json");
const faqs = require("./locationFaq.json");
const locations = require("./locations.json").map((l) => ({ ...l, blocks: [...l.blocks, extra[l.slug]], faqs: faqs[l.slug] }));

const SITE = {
  url: "https://christian-bedachungen.de",
  name: "Christian Bedachungen",
  phone: "+491632983216",
  email: "christiangbr2000@gmail.com",
  image: "https://christian-bedachungen.de/img/og-image.jpg",
  logo: "https://christian-bedachungen.de/logo.png",
};

const AREAS = ["Schifferstadt", "Speyer", "Ludwigshafen am Rhein", "Mannheim", "Frankenthal (Pfalz)", "Limburgerhof", "Böhl-Iggelheim", "Haßloch", "Mutterstadt", "Dudenhofen", "Römerberg", "Neustadt an der Weinstraße", "Schwetzingen", "Hockenheim", "Worms"];

const HOME = {
  path: "/",
  title: "Dachdecker Schifferstadt & Speyer | Meisterbetrieb seit 2008 | Christian Bedachungen",
  description: "Dachdecker in Schifferstadt & Speyer: Meisterbetrieb seit 2008. Festpreis-Garantie, kostenlose Besichtigung in 48 h, 24h Sturmschaden-Notdienst.",
};

const EXTRA = [
  { path: "/einsatzgebiet", title: "Einsatzgebiet Dachdecker Schifferstadt & Speyer | Christian Bedachungen", description: "Unser Einsatzgebiet: Schifferstadt, Speyer und rund 25 km Umkreis – von Ludwigshafen und Mannheim bis Neustadt, Schwetzingen und Worms.", h1: "Unser Einsatzgebiet rund um Schifferstadt und Speyer" },
  { path: "/kontakt", title: "Kontakt Dachdecker Schifferstadt | Christian Bedachungen", description: "Kontakt zu Christian Bedachungen, Hauptstr. 3, 67105 Schifferstadt. Telefon 0163 2983216, WhatsApp oder Formular – Rückmeldung innerhalb von 24 h.", h1: "Kontakt zu Ihrem Dachdecker in Schifferstadt" },
  { path: "/impressum", title: "Impressum | Christian Bedachungen – Dachdecker Schifferstadt", description: "Impressum von Christian Bedachungen, Dachdecker-Meisterbetrieb in Schifferstadt.", h1: "Impressum" },
  { path: "/datenschutz", title: "Datenschutzerklärung | Christian Bedachungen – Dachdecker Schifferstadt", description: "Datenschutzerklärung von Christian Bedachungen, Dachdecker-Meisterbetrieb in Schifferstadt.", h1: "Datenschutzerklärung" },
];

const abs = (path) => `${SITE.url}${path === "/" ? "/" : path}`;

const businessLd = () => ({
  "@context": "https://schema.org",
  "@type": ["RoofingContractor", "LocalBusiness"],
  "@id": `${SITE.url}/#business`,
  name: SITE.name,
  url: `${SITE.url}/`,
  logo: SITE.logo,
  image: SITE.image,
  telephone: SITE.phone,
  email: SITE.email,
  foundingDate: "2008",
  address: { "@type": "PostalAddress", streetAddress: "Hauptstr. 3", postalCode: "67105", addressLocality: "Schifferstadt", addressRegion: "Rheinland-Pfalz", addressCountry: "DE" },
  openingHoursSpecification: [{ "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "06:00", closes: "20:00" }],
  areaServed: AREAS.map((name) => ({ "@type": "City", name })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Dachdeckerleistungen",
    itemListElement: services.map((s) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: s.name, url: abs(`/${s.slug}`) } })),
  },
});

const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: abs(it.path) })),
});

const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

const serviceLd = (s) => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: s.h1,
    serviceType: s.name,
    description: s.description,
    url: abs(`/${s.slug}`),
    provider: { "@id": `${SITE.url}/#business` },
    areaServed: AREAS.map((name) => ({ "@type": "City", name })),
  },
  breadcrumbLd([{ name: "Startseite", path: "/" }, { name: s.name, path: `/${s.slug}` }]),
  faqLd(s.faqs),
];

const locationLd = (l) => [breadcrumbLd([{ name: "Startseite", path: "/" }, { name: "Einsatzgebiet", path: "/einsatzgebiet" }, { name: `Dachdecker ${l.city}`, path: `/${l.slug}` }]), faqLd(l.faqs)];

const ALL_PAGES = [
  HOME,
  ...services.map((s) => ({ path: `/${s.slug}`, title: s.title, description: s.description })),
  ...locations.map((l) => ({ path: `/${l.slug}`, title: l.title, description: l.description })),
  ...EXTRA,
];

module.exports = { SITE, AREAS, HOME, EXTRA, services, locations, abs, businessLd, serviceLd, locationLd, breadcrumbLd, ALL_PAGES };
